import { configureRootStore } from './types/root-store.functions'
import { Store } from 'redux'

export const RootStore: Store = configureRootStore()
